export default __webpack_public_path__ + "78574ca8dd207d76f71617f0f288bca9.svg";